import View from 'components/dashboard/DashboardView';

export default { View };



// WEBPACK FOOTER //
// src/components/dashboard/index.js